import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from "dayjs";
import { navigate } from "gatsby";
// import { loginWithEmailAndPassword } from "../../../utils/firebase";
import { createKlaviyoProfile } from "../../../utils/klaviyo";
import { readAttribution } from "../../../utils/fbAttribution";
import { quizResultPath } from "../../../utils/quizResultAnalytics";
function trackQuizEvent(name, params) {
  import("../../../utils/firebase")
    .then(({ analytics, logEvent }) => {
      if (analytics) logEvent(analytics, name, params);
    })
    .catch(() => {});
}

export const fetchQuestions = createAsyncThunk(
  "quiz/fetchQuestions",
  async () => {
    let data = JSON.stringify({
      query:
        "query getAnonymoysQuizes { quizzes { id name quizQuestions { id order question question_type quizQuestionAnswers { id answer } } } }",
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };
    let response = axios
      .request(config)
      .then((response) => {
        if (response.data) {
          let questionsArr = response.data.data.quizzes.find(
            (el) => el.id === 2,
          );
          return questionsArr.quizQuestions;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return response;
  },
);
export const createChildAnonymousQuiz = createAsyncThunk(
  "quiz/createChildAnonymousQuiz",
  async () => {
    let data = JSON.stringify({
      query:
        "mutation ($input: ChildAnonymousQuizInput!) { createChildAnonymousQuiz(input: $input) { id user_id user{email} child_id } }",
      variables: {
        input: {
          quiz_id: 2,
          completed: false,
        },
      },
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };
    let response2 = axios
      .request(config)
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return response2;
  },
);

export const getQuizProgress = createAsyncThunk(
  "quiz/getQuizProgress",
  async (props) => {
    let data = JSON.stringify({
      query:
        "query getAnonymousChildQuiz($childQuizId: Int!) { childQuiz(id: $childQuizId) { id user_id child_id quiz_id completed quizAnswers { id quiz_id user_id answer question_id question_type quizQuestionAnswers { id answer answerSkillValues { id value skill { id name } } quizQuestion { id question order } } } } }",
      variables: {
        childQuizId: Number(props.quiz_id),
      },
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };
    let response2 = axios
      .request(config)
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return response2;
  },
);

export const createQuizAnswer = createAsyncThunk(
  "quiz/createQuizAnswer",
  async (props) => {
    let data = JSON.stringify({
      query:
        "mutation ($input: QuizAnswerInput!) { createQuizAnswer(input: $input) { question_id child_quiz_id } }",
      variables: {
        input: {
          user_id: Number(props.startedQuiz.user_id),
          quiz_id: 2,
          question_id: Number(props.selectedAnswer.questionId),
          question_type: props.selectedAnswer.questionType,
          child_quiz_id: Number(props.startedQuiz.quiz_id),
          answer: props.selectedAnswer.answer,
          quiz_question_answer_ids: [Number(props.selectedAnswer.answerId)],
        },
      },
    });
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("trackCustom", "question_answered", {
        profileId: Number(props.startedQuiz.user_id),
        question_id: Number(props.selectedAnswer.questionId),
        quiz_id: 2,
        quiz_question_answer_ids: props.selectedAnswer.answer.answerId,
      });
    }
    // await fetch("/api/createKlaviyoEvent", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({
    //     email: props.startedQuiz.user_email,
    //     eventName: "question_answered",
    //     properties: {
    //       profileId: Number(props.startedQuiz.user_id),
    //       question_id: Number(props.selectedAnswer.questionId),
    //       quiz_id: 2,
    //       quiz_question_answer_ids: props.selectedAnswer.answer.answerId,
    //     },
    //   }),
    // });
    trackQuizEvent("question_answered", {
      profileId: Number(props.startedQuiz.user_id),
      question_id: Number(props.selectedAnswer.questionId),
      quiz_id: 2,
      quiz_question_answer_ids: props.selectedAnswer.answer.answerId,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };
    let response2 = axios
      .request(config)
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return response2;
  },
);

export const updateChildQuizUser = createAsyncThunk(
  "quiz/updateChildQuizUser",
  async (props) => {
    let age = dayjs().diff(dayjs(props.formData.date), "month");
    let data = JSON.stringify({
      query:
        "mutation ($input: ChildQuizUserInput!) { updateChildQuizUser(input: $input) { id email displayName currentChildId } }",
      variables: {
        input: {
          email: props.startedQuiz.user_email,
          new_email: props.formData.email,
          name: props?.formData?.name || "",
          birthDate: props?.formData?.date || "",
          age: age,
          completed: true,
          password: props.formData.password,
          gender: props?.formData?.gender || "",
        },
      },
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website":
          "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd",
      },
      data: data,
    };
    let response2 = axios
      .request(config)
      .then(async (response) => {
        if (typeof window !== "undefined" && window.fbq) {
          window.fbq("trackCustom", "child_add", {
            child_id: props.startedQuiz.child_id,
            child_name: props.formData.name,
          });
        }
        // The profile call subscribes the email (and lifts a suppression), so it
        // must finish before quiz_finish triggers the flow. Klaviyo errors must
        // never stop the quiz from reaching its result page.
        try {
          await createKlaviyoProfile(
            props.formData.name,
            props.formData.email,
            props.startedQuiz.user_email,
            props.startedQuiz.child_id,
            "online_quiz",
            readAttribution(),
          );
        } catch (error) {
          console.log("❌ Klaviyo profile failed", error);
        }

        try {
          const klaviyoQuizFinishedEventRes = await fetch(
            "/api/createKlaviyoEvent",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: props.formData.email,
                eventName: "quiz_finish",
                properties: {
                  quiz_id: props.startedQuiz.quiz_id,
                  child_id: props.startedQuiz.child_id,
                  user_id: props.startedQuiz.user_id,
                },
              }),
            },
          );

          if (!klaviyoQuizFinishedEventRes.ok) {
            console.log("❌ quiz_finish event  failed");
          } else {
            console.log("✅ quiz_finish event success");
          }
        } catch (error) {
          console.log("❌ quiz_finish event  failed", error);
        }

        trackQuizEvent("child_add", {
          child_id: props.startedQuiz.child_id,
          child_name: props.formData.name,
        });
        // loginWithEmailAndPassword(
        //   props.formData.email,
        //   props.formData.password
        // );
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return response2;
  },
);

const initialState = {
  questions: [
    {
      id: 6,
      order: 1,
      question:
        "В ежедневието обичайно колко дълго задържа вниманието си в една дейност?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 11,
          answer: "10-15 мин.",
        },
        {
          id: 12,
          answer: "15-30 мин.",
        },
        {
          id: 13,
          answer: "над 30 мин.",
        },
        {
          id: 9,
          answer: "1-2 мин.",
        },
        {
          id: 10,
          answer: "5-10 мин.",
        },
      ],
    },
    {
      id: 7,
      order: 2,
      question:
        "А колко максимум може да задържи вниманието си в една дейност?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 14,
          answer: "1-2 мин.",
        },
        {
          id: 15,
          answer: "5-10 мин.",
        },
        {
          id: 16,
          answer: "10-15 мин.",
        },
        {
          id: 17,
          answer: "15-30 мин.",
        },
        {
          id: 18,
          answer: "над 30 мин.",
        },
      ],
    },
    {
      id: 22,
      order: 3,
      question: "Кои цветове познава и може да назове?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 78,
          answer: "Не познава цветовете",
        },
        {
          id: 79,
          answer: "Знае основните (червено, жълто, синьо)",
        },
        {
          id: 80,
          answer:
            "Знае основните и някои техни разновидности (оранжево, жълто, розово и др.)",
        },
        {
          id: 81,
          answer:
            "Знае основните и техните разновидности (всички цветове на дъгата + черно и бяло)",
        },
        {
          id: 82,
          answer: "Знае всички цветове и техните нюанси (тъмно-светло)",
        },
      ],
    },
    {
      id: 8,
      order: 4,
      question: "Как бихте определите речта на детето?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 19,
          answer: "Не говори",
        },
        {
          id: 20,
          answer:
            "Съставя кратки изречения, но по бебешки (основно аз му разбирам, чужд човек не може да го разбере)",
        },
        {
          id: 21,
          answer:
            "Говори, разбират го и други хора, но понякога придъвква думите ",
        },
        {
          id: 22,
          answer: "Има изчистена реч, съставя кратки (прости) изречения",
        },
        {
          id: 23,
          answer:
            "Речта е изчистена, съставя дълги изречения и обича да разказва за случващото се.",
        },
      ],
    },
    {
      id: 20,
      order: 5,
      question: "Колко букви от азбуката познава?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 68,
          answer: "Не познава / познава 1-2 букви",
        },
        {
          id: 69,
          answer: "Познава 3-5 букви",
        },
        {
          id: 70,
          answer: "Познава 5-10 букви",
        },
        {
          id: 71,
          answer: "Познава 10-20 букви",
        },
        {
          id: 72,
          answer: "Познава всички букви от азбуката",
        },
      ],
    },
    {
      id: 21,
      order: 6,
      question: "Разпознава ли звуците в думите (първи, последен, среден)?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 73,
          answer: "Не разпознава звуците в думите",
        },
        {
          id: 74,
          answer: "Разпознава първи звук",
        },
        {
          id: 75,
          answer: "Разпознава първи и последен звук",
        },
        {
          id: 76,
          answer: "Разпознава първи, последен и среден звук в думите",
        },
        {
          id: 77,
          answer: "Разпознава и ги свързва в срички / вече чете",
        },
      ],
    },
    {
      id: 19,
      order: 7,
      question: "Детето храни ли се самостоятелно?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 64,
          answer: "Може да се храни отчасти само̀, но по-често го храня аз",
        },
        {
          id: 65,
          answer: "Може с вилица, но с лъжица му е трудно и го храня аз",
        },
        {
          id: 66,
          answer: "Все още се затруднява (аз го храня)",
        },
        {
          id: 63,
          answer: "Да, но се цапа",
        },
        {
          id: 62,
          answer: "Да и пази чисто.",
        },
      ],
    },
    {
      id: 9,
      order: 8,
      question: "По време на хранене как държи приборите?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 24,
          answer: "Все още не умее да се храни само̀",
        },
        {
          id: 25,
          answer: "Юмручен захват (с цяла длан)",
        },
        {
          id: 26,
          answer: "Опитва се с 3 пръста, но е още несръчен/а",
        },
        {
          id: 27,
          answer: "Трипръстов захват (както се държи молив)",
        },
      ],
    },
    {
      id: 10,
      order: 9,
      question: "Може ли да се облича и обува само?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 28,
          answer: "Да",
        },
        {
          id: 29,
          answer: "Да, но невинаги облича правилно дрехите",
        },
        {
          id: 30,
          answer: "Да, но с помощ при обличането",
        },
        {
          id: 31,
          answer: "Опитва се, но с помощ и при обличането, и при събличането",
        },
        {
          id: 32,
          answer: "Не може сам/а и не се опитва",
        },
      ],
    },
    {
      id: 11,
      order: 10,
      question: "Прибира ли си играчките след игра?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 33,
          answer: "Да, без подкана",
        },
        {
          id: 34,
          answer: "Да, но трябва да му/ѝ напомням",
        },
        {
          id: 35,
          answer: "Да, но с напомняне и помощ при прибирането",
        },
        {
          id: 36,
          answer: "Не/Много трудно",
        },
      ],
    },
    {
      id: 12,
      order: 11,
      question: "Спи ли детето следобяд?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 37,
          answer: "Да, всеки ден е по едно и също време ",
        },
        {
          id: 39,
          answer: "Невинаги; само когато на него му се доспи",
        },
        {
          id: 67,
          answer: "Не спи следобед, но вечер няма признаци на умора",
        },
        {
          id: 40,
          answer: "Не спи следобяд и вечер е видимо уморен/а и кисел/а",
        },
        {
          id: 38,
          answer:
            "Да, но всеки ден е по различно време / В градината спи, но вкъщи не",
        },
      ],
    },
    {
      id: 13,
      order: 12,
      question: "Заиграва ли се само детето?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 41,
          answer: "Да, за дълго",
        },
        {
          id: 42,
          answer: "Да, но за кратко",
        },
        {
          id: 43,
          answer: "Понякога, но предпочита компания",
        },
        {
          id: 44,
          answer: "Не, винаги търси мен или друг, с когото да играе",
        },
      ],
    },
    {
      id: 14,
      order: 13,
      question: "Заиграва ли се с други деца?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 45,
          answer: "Да, играе пълноценно и в разбирателство",
        },
        {
          id: 46,
          answer: "Да, но понякога по-трудно споделя играчките",
        },
        {
          id: 47,
          answer: "Да, но често има конфликти",
        },
        {
          id: 48,
          answer:
            "Да, но трябва да съм край него/нея, за да помагам в общуването",
        },
        {
          id: 49,
          answer: "Не, предпочита да играе сам/а",
        },
      ],
    },
    {
      id: 15,
      order: 14,
      question: "Колко предмета може сам да отброи?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 50,
          answer: "Не може да отброява",
        },
        {
          id: 51,
          answer: "Може да преброи до 3 предмета",
        },
        {
          id: 52,
          answer: "Може да преброи до 5 предмета",
        },
        {
          id: 53,
          answer: "Може да преброи между 6 и 10 предмета",
        },
        {
          id: 54,
          answer: "Може да преброи повече от 10 предмета",
        },
      ],
    },
    {
      id: 16,
      order: 15,
      question:
        "Може ли да разпознае числата, когато са написани (техните символи)?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 55,
          answer: "Още не",
        },
        {
          id: 56,
          answer: "Разпознава числата до 3",
        },
        {
          id: 57,
          answer: "Разпознава числата до 5",
        },
        {
          id: 58,
          answer: "Разпознава числата до 10",
        },
        {
          id: 59,
          answer: "Разпознава някои от числата и над 10",
        },
      ],
    },
    {
      id: 18,
      order: 16,
      question: "Детето със специални образователни потребности (СОП)* ли е?",
      question_type: 1,
      quizQuestionAnswers: [
        {
          id: 60,
          answer: "Да",
        },
        {
          id: 61,
          answer: "Не",
        },
      ],
    },
  ],
  currentQuestion: 0,
  selectedAnswer: null,
  finished: false,
  startedQuiz: null,
  answeredQuestions: [],
  // error: null,
  error: null,
  loginUser: false,
};

export const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setLoginUser: (state, { payload }) => {
      state.loginUser = payload;
    },
    setCurrentQuestion: (state, { payload }) => {
      state.currentQuestion = payload;
    },
    toggleAnswer: (state, { payload }) => {
      if (state.selectedAnswer?.answerId === payload.answerId) {
        state.selectedAnswer = null;
      } else {
        state.selectedAnswer = payload;
      }
    },
    resetSelectedAnswer: (state) => {
      state.selectedAnswer = null;
    },
    //  on page reload get data from cookies and set it to state.startedQuiz
    setStartedQuiz: (state) => {
      let userIdCookie = document.cookie
        .split(";")
        .find((el) => el.includes("user_id"));
      let quizIdCookie = document.cookie
        .split(";")
        .find((el) => el.includes("quiz_id"));
      let childIdCookie = document.cookie
        .split(";")
        .find((el) => el.includes("child_id"));
      let userEmailCookie = document.cookie
        .split(";")
        .find((el) => el.includes("user_email"));
      if (userIdCookie && quizIdCookie && childIdCookie && userEmailCookie) {
        state.startedQuiz = {
          user_id: userIdCookie.split("=")[1],
          quiz_id: quizIdCookie.split("=")[1],
          child_id: childIdCookie.split("=")[1],
          user_email: userEmailCookie.split("=")[1],
        };
      }
    },
    finishQuiz: (state) => {
      state.finished = true;
    },
    notFinishQuiz: (state) => {
      state.finished = false;
    },
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // get quiz questions and answers from server
    builder.addCase(fetchQuestions.fulfilled, (state, action) => {
      if (action.payload.errors) {
        let errors = action.payload.errors.map((el) => el.message);
        state.error = {
          type: "fetchQuestions",
          message: errors.join(" "),
        };
      } else {
        state.questions = action.payload.sort((a, b) => a.order - b.order);
        state.error = null;
      }
    });
    builder.addCase(fetchQuestions.rejected, (state, action) => {
      console.log(action.error);
      state.error = {
        type: "fetchQuestions",
        message:
          "Нещо се обърка. Моля опитайте отново да попълните въпросника по-късно.",
      };
    });
    builder.addCase(fetchQuestions.pending, (state, action) => {
      // console.log("pending");
    });

    // create anonymous quiz for child
    builder.addCase(createChildAnonymousQuiz.fulfilled, (state, action) => {
      if (action?.payload?.data?.createChildAnonymousQuiz) {
        if (typeof window !== "undefined" && window.fbq) {
          window.fbq("trackCustom", "create_child_quiz", {
            create_child_quiz_id:
              action?.payload?.data?.createChildAnonymousQuiz?.id,
          });
        }
        trackQuizEvent("create_child_quiz", {
          create_child_quiz_id:
            action?.payload?.data?.createChildAnonymousQuiz?.id,
        });
        // fetch("/api/createKlaviyoEvent", {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({
        //     email: action?.payload?.data?.createChildAnonymousQuiz?.user?.email,
        //     eventName: "create_child_quiz",
        //     properties: {
        //       child_quiz_id:
        //         action?.payload?.data?.createChildAnonymousQuiz?.id,
        //     },
        //   }),
        // });
      }

      if (action.payload.errors) {
        let errors = action.payload.errors.map((el) => el.message);
        state.error = {
          type: "createChildAnonymousQuiz",
          message: errors.join(" "),
        };
      } else {
        if (action.payload.data) {
          const d = new Date();
          d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();

          document.cookie =
            `user_id=${action.payload.data.createChildAnonymousQuiz.user_id};` +
            expires;
          document.cookie =
            `quiz_id=${action.payload.data.createChildAnonymousQuiz.id};` +
            expires;
          document.cookie =
            `child_id=${action.payload.data.createChildAnonymousQuiz.child_id};` +
            expires;
          document.cookie =
            `user_email=${action.payload.data.createChildAnonymousQuiz.user.email};` +
            expires;
          state.startedQuiz = {
            user_id: action.payload.data.createChildAnonymousQuiz.user_id,
            quiz_id: action.payload.data.createChildAnonymousQuiz.id,
            child_id: action.payload.data.createChildAnonymousQuiz.child_id,
            user_email: action.payload.data.createChildAnonymousQuiz.user.email,
          };
          state.error = null;
        }
      }
    });
    builder.addCase(createChildAnonymousQuiz.rejected, (state, action) => {
      console.log(action.error);
      state.error = {
        type: "createChildAnonymousQuiz",
        message:
          "Нещо се обърка. Моля опитайте отново да попълните въпросника по-късно.",
      };
    });
    builder.addCase(createChildAnonymousQuiz.pending, (state, action) => {
      // console.log("pending");
    });

    // send question answer to server
    builder.addCase(createQuizAnswer.fulfilled, (state, action) => {
      if (action.payload.errors) {
        let errors = action.payload.errors.map((el) => el.message);
        state.error = {
          type: "createQuizAnswer",
          message: errors.join(" "),
        };
      } else {
        // console.log(action, "createQuizAnswer tuk");
        state.error = null;
      }
    });
    builder.addCase(createQuizAnswer.rejected, (state, action) => {
      console.log(action.error);
      state.error = {
        type: "createQuizAnswer",
        message:
          "Нещо се обърка. Моля опитайте отново да отговорите на въпроса.",
      };
    });
    builder.addCase(createQuizAnswer.pending, (state, action) => {
      // console.log("pending");
    });

    // update child quiz user with user data
    builder.addCase(updateChildQuizUser.fulfilled, (state, action) => {
      const childId =
        action?.payload?.data?.updateChildQuizUser?.currentChildId;
      if (action?.payload?.errors) {
        console.log("errors", action?.payload?.errors);
        let errors = action?.payload?.errors?.map((el) => el.message);
        state.error = {
          type: "updateChildQuizUser",
          message: errors.join(" "),
        };
      } else {
        state.loginUser = true;
        state.answeredQuestions = [];
        state.startedQuiz = null;
        state.currentQuestion = 0;
        state.selectedAnswer = null;
        state.finished = false;

        state.error = null;
        // navigate("/results");

        navigate(quizResultPath(childId));
      }
    });
    builder.addCase(updateChildQuizUser.rejected, (state, action) => {
      state.error = {
        type: "updateChildQuizUser",
        message: "Нещо се обърка. Моля опитайте отново да изпратите формата.",
      };
    });
    builder.addCase(updateChildQuizUser.pending, (state, action) => {
      // console.log("pending");
    });

    // get quiz progress from server
    builder.addCase(getQuizProgress.fulfilled, (state, action) => {
      state.answeredQuestions = action.payload.data.childQuiz.quizAnswers;
      // state.answeredQuestions = action?.payload?.data?.childQuiz?.quizAnswers?.map(
      //   (el) => el.question_id
      // );
      state.error = null;
    });
    builder.addCase(getQuizProgress.rejected, (state, action) => {
      state.error = {
        type: "getQuizProgress",
        message:
          "Нещо се обърка. Моля опитайте отново да попълните въпросника по-късно.",
      };
    });
    builder.addCase(getQuizProgress.pending, (state, action) => {
      // console.log("pending");
    });
  },
});

export const {
  setCurrentQuestion,
  selectUnselectAnswer,
  finishQuiz,
  notFinishQuiz,
  startQuiz,
  toggleAnswer,
  resetSelectedAnswer,
  setStartedQuiz,
  resetError,
  setLoginUser,
} = quizSlice.actions;
export default quizSlice.reducer;
